// extracted by mini-css-extract-plugin
export default {"wrapper":"Subject_wrapper__Gza+5","title":"Subject_title__1dTJN","content":"Subject_content__qJ6Ee","separator":"Subject_separator__MMnbD"};